import { API_BASE, DEFAULT_HEADERS } from "./apiClient";
import { profilePath } from "./profilePath";

/**
 * Opens someone else's profile at its readable address (/in/theirname),
 * falling back to /profileextern/:publicId only when they have no slug.
 * This fetch is also what mints a slug for a member who has none yet, so the
 * address is ready by the time we navigate.
 * Always stores extern_profile snapshot for fallback.
 */
export async function openExternalProfile(navigate, userId) {
  if (!userId) return;

  const res = await fetch(
    `${API_BASE}/wineries/profile?user_id=${encodeURIComponent(userId)}`,
    {
      headers: {
        "Content-Type": "application/json",
        ...DEFAULT_HEADERS,
      },
    }
  );

  if (!res.ok) throw new Error(`Failed to load profile (${res.status})`);
  const payload = await res.json(); // { user, profile }

  // store snapshot (for /profileextern fallback mode)
  try {
    localStorage.setItem("extern_user_id", String(payload?.user?.id ?? userId));
    localStorage.setItem("extern_profile", JSON.stringify(payload));
  } catch (_) {}

  const to = profilePath(payload);

  if (to) navigate(to);
  else navigate("/profileextern");
}
